import { render, staticRenderFns } from "./SidebarChildItem.vue?vue&type=template&id=384d86c9"
import script from "./SidebarChildItem.vue?vue&type=script&lang=js"
export * from "./SidebarChildItem.vue?vue&type=script&lang=js"
import style0 from "./SidebarChildItem.vue?vue&type=style&index=0&id=384d86c9&prod&lang=scss"
import style1 from "./SidebarChildItem.vue?vue&type=style&index=1&id=384d86c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports